import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BlogListSortOption, BlogListSortType } from '@core/enums/blog-list-sort-type';
import { BlogCategory } from '@core/store/blog/blog-state-models';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-blog-list-header',
  templateUrl: './blog-list-header.component.html',
  styleUrls: ['./blog-list-header.component.scss'],
})
export class BlogListHeaderComponent implements OnInit, OnDestroy {
  @Output()
  sortChange: EventEmitter<BlogListSortType>;

  @Input() blogCategories: BlogCategory[];

  sortOptions: { key: string; name: string }[];
  selectedCategoryName: string;
  selectedCategoryUrl: string;
  selectedSortOption = BlogListSortOption.NewestFirst;

  activatedRouteSubscription: Subscription;

  constructor(private activatedRoute: ActivatedRoute, private router: Router) {
    this.sortChange = new EventEmitter<BlogListSortType>();
    this.sortOptions = Object.keys(BlogListSortOption).map((key) => ({
      key,
      name: BlogListSortOption[key],
    }));
    this.selectedCategoryName = 'All Blogs';
    this.selectedCategoryUrl = '';
  }

  ngOnInit(): void {
    this.activatedRouteSubscription = this.activatedRoute.paramMap.subscribe((pMap) => {
      const categoryNameParam = pMap.get('category');
      const selectedCategory = this.blogCategories?.find((x) => x.urlName == categoryNameParam);
      if (selectedCategory === undefined) {
        this.router.navigate(['/recipes-more/blogs']);
      } else {
        this.selectedCategoryUrl = selectedCategory.urlName;
        this.selectedCategoryName = selectedCategory.title;
      }
    });
  }

  ngOnDestroy(): void {
    this.activatedRouteSubscription.unsubscribe();
  }

  sortOrderClickHandler(key: BlogListSortType) {
    this.selectedSortOption = BlogListSortOption[String(key)];
    this.sortChange.emit(key);
  }
}
